import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';

export class GcsService {
  static async upload(file: File): Promise<{ path: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response: AxiosResponse<{ path: string }> = await AxiosService.post('/file/gcs/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  }

  static async getSignedUrl(path: string): Promise<string> {
    const response: AxiosResponse<{ url: string }> = await AxiosService.get('/file/gcs/signed-url', {
      params: { path },
    });
    return response.data.url;
  }

  /** Los archivos gestionados por GCS se guardan como path (`org/archivo.ext`), no como URL absoluta. */
  static isManagedPath(value?: string): boolean {
    return !!value && !/^https?:\/\//i.test(value);
  }
}
